/* tslint:disable */
/* eslint-disable */
/**
 * radia.cz
 * Seznam endpointu
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface FrontWebHeaderModel
 */
export interface FrontWebHeaderModel {
    /**
     * title
     * @type {string}
     * @memberof FrontWebHeaderModel
     */
    title: string;
    /**
     * desc
     * @type {string}
     * @memberof FrontWebHeaderModel
     */
    description: string;
    /**
     * sitename
     * @type {string}
     * @memberof FrontWebHeaderModel
     */
    siteName: string;
    /**
     * image
     * @type {string}
     * @memberof FrontWebHeaderModel
     */
    image: string;
    /**
     * url
     * @type {string}
     * @memberof FrontWebHeaderModel
     */
    url: string;
}

/**
 * Check if a given object implements the FrontWebHeaderModel interface.
 */
export function instanceOfFrontWebHeaderModel(value: object): boolean {
    let isInstance = true;
    isInstance = isInstance && "title" in value;
    isInstance = isInstance && "description" in value;
    isInstance = isInstance && "siteName" in value;
    isInstance = isInstance && "image" in value;
    isInstance = isInstance && "url" in value;

    return isInstance;
}

export function FrontWebHeaderModelFromJSON(json: any): FrontWebHeaderModel {
    return FrontWebHeaderModelFromJSONTyped(json, false);
}

export function FrontWebHeaderModelFromJSONTyped(json: any, ignoreDiscriminator: boolean): FrontWebHeaderModel {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'title': json['title'],
        'description': json['description'],
        'siteName': json['siteName'],
        'image': json['image'],
        'url': json['url'],
    };
}

export function FrontWebHeaderModelToJSON(value?: FrontWebHeaderModel | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'title': value.title,
        'description': value.description,
        'siteName': value.siteName,
        'image': value.image,
        'url': value.url,
    };
}

